import { createContext, useContext, useEffect, useReducer } from "react";

export const EarthquakeContext = createContext({});

export const useEarthquakeContext = () => {
  return useContext(EarthquakeContext);
};

const reducer = (state, action) => {
  switch (action.type) {
    case "getFiveMgEarthquake":
      return { ...state, fiveMgEarthquake: action.payload };
    case "getFeltEarthquake":
      return { ...state, feltEarthquake: action.payload };
    case "isLoading":
      return { ...state, isLoading: action.payload };
    default:
      throw Error(`Unhandled action type: ${action.type}`);
  }
};

const initialState = {
  feltEarthquake: {},
  fiveMgEarthquake: {},
  isLoading: true,
};

export const EarthquakeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getFeltEarthquake = async () => {
      try {
        const req = await fetch(
          "https://zen-dom.up.railway.app/gempadirasakan",
          {
            headers: {
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          }
        );
        if (req.status !== 200) {
          throw Error("FAILED to FETCH");
        }
        const res = await req.json();
        const result = res.Infogempa.gempa.map((item) => ({
          ...item,
          Jam: item.Jam.substr(0, 5),
        }));
        if (isMounted) {
          dispatch({ type: "getFeltEarthquake", payload: result });
          dispatch({ type: "isLoading", payload: false });
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        throw Error(err);
      }
    };
    const getFiveMgEarthquake = async () => {
      try {
        const req = await fetch(
          "https://zen-dom.up.railway.app/gempaterkini",
          {
            headers: {
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          }
        );
        if (req.status !== 200) {
          throw Error("FAILED to FETCH");
        }
        const res = await req.json();
        const result = res.Infogempa.gempa.map((item) => ({
          ...item,
          Jam: item.Jam.substr(0, 5),
        }));
        if (isMounted) {
          dispatch({ type: "getFiveMgEarthquake", payload: result });
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        throw Error(err);
      }
    };
    getFiveMgEarthquake();
    getFeltEarthquake();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const EarthquakeContextValue = [state, dispatch];
  return (
    <EarthquakeContext.Provider value={EarthquakeContextValue}>
      {children}
    </EarthquakeContext.Provider>
  );
};
